export default "__VITE_ASSET__DcE_kz0m__"